import { useEffect, useRef, useState } from "react";
import { SHORTCUT_DEFS, TOGGLE_SHORTCUT_HELP_EVENT } from "@/lib/shortcut-defs";
import { formatCombo, isMacPlatform, matchesCombo } from "@/lib/shortcuts";

export function ShortcutHelpDialog() {
	const dialogRef = useRef<HTMLDialogElement>(null);
	const [open, setOpen] = useState(false);
	const [isMac] = useState(isMacPlatform);

	useEffect(() => {
		const toggle = () => setOpen((current) => !current);
		window.addEventListener(TOGGLE_SHORTCUT_HELP_EVENT, toggle);
		return () => window.removeEventListener(TOGGLE_SHORTCUT_HELP_EVENT, toggle);
	}, []);

	useEffect(() => {
		const dialog = dialogRef.current;
		if (open && dialog && !dialog.open) dialog.showModal();
	}, [open]);

	if (!open) return null;

	return (
		<dialog
			ref={dialogRef}
			className="fixed inset-0 z-50 m-auto w-[440px] max-w-[calc(100vw-32px)] rounded-4 border border-line-1 bg-surface-1 p-0 shadow-popover outline-none backdrop:bg-scrim"
			data-testid="shortcut-help-dialog"
			onClose={() => setOpen(false)}
			onKeyDown={(event) => {
				const helpShortcut = SHORTCUT_DEFS.find(
					(shortcut) => shortcut.id === "toggle-shortcut-help",
				);
				if (
					event.key === "Escape" ||
					(helpShortcut && matchesCombo(event.nativeEvent, helpShortcut.combo, isMac))
				) {
					event.preventDefault();
					setOpen(false);
				}
			}}
		>
			<div className="px-5 pt-5 pb-4">
				<h3 className="text-ui font-semibold text-fg-1">キーボードショートカット</h3>
				<div className="mt-4 space-y-1">
					{SHORTCUT_DEFS.map((shortcut) => (
						<div
							key={shortcut.id}
							className="flex items-center justify-between gap-6 rounded-2 px-2 py-1.5 text-caption text-fg-2"
						>
							<span>{shortcut.description}</span>
							<kbd className="rounded-2 border border-line-1 bg-surface-2 px-1.5 py-0.5 font-mono text-caption text-fg-1">
								{formatCombo(shortcut.combo, isMac)}
							</kbd>
						</div>
					))}
				</div>
			</div>
		</dialog>
	);
}
